import { ChangeEvent, FC, PropsWithChildren as ReactPropsWithChildren } from 'react';

export type NullableObject<T> = {
  [P in keyof T]: T[P] | null;
};

export type Nullable<T> = T | null;

export type NullableNumber = Nullable<number>;

export type NullableString = Nullable<string>;

export type VoidHandler = () => void;

export type EventHandler<TEvent = unknown> = (e: TEvent) => void;

export type ReactChangeHandler = (e: ChangeEvent<{ name?: string; value: unknown }>) => void;

export type EmptyObject = Record<string, unknown>;

// Single entry for 'any' type. Should be used with accuracy.

export type TAny = any;

export type PropsWithChildren<T = EmptyObject> = ReactPropsWithChildren<T>;

export type ComponentWithChildren<T = EmptyObject> = FC<PropsWithChildren<T>>;

export interface IBaseEntity {
  addedAt: string;
  deleted: boolean;
  id: string;
  lastEditor: string;
  lastEditorId: string;
  updatedAt: string;
}

export interface ISlugEntity {
  slug: string;
}

export interface INameEntity {
  name: string;
}

export interface IEditor extends IBaseEntity {
  email: string;
  githubId: string;
  githubUsername: string;
  platformUserId: string;
  username: string;
}

export enum ESortDirection {
  DESC = 'DESC',
  ASC = 'ASC',
}

export interface IListResponse<T = unknown> {
  items: T[];
  metadata: {
    cursor?: string;
    sort: string;
    sortDirection: ESortDirection;
  };
}

export interface IErrorMessage {
  type: string;
  error: string;
}

export enum EFileType {
  ARCHIVE = 'archive',
  INDIVIDUAL = 'individual',
}

export interface IModalDetails {
  title: string;
  description: string;
}
